import { Config } from '../utils/EnvironmentUtils'

export const ENABLE_DATA_SANITIZATION = Config.ENABLE_DATA_SANITIZATION
   ? Config.ENABLE_DATA_SANITIZATION === 'true'
   : false
